// autogenerated by channel_search/generate.py -- do not edit
import { VehicleSettings } from "@skydio/pbtypes/pbtypes/vehicle/infrastructure/flight_deck/settings_pb";
export { VehicleSettings };

export const UPDATE_VEHICLE_SETTINGS_PB = {
  channel: "UPDATE_VEHICLE_SETTINGS_PB",
  channelId: 9039,
  type: VehicleSettings.deserializeBinary
};
